module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vskel2-d23b80089ace2f96209809352c3631c8.jpg";